import axios from 'axios' //引用
import { getToken,DelToken,DelUserInfo,refreshToken } from "./operateToken";
let http=axios.create();
http.defaults.withCredentials = true; // 允许携带cookie

/* 被挂起的请求数组 */
let refreshSubscribers = []

/* push所有请求到数组中 */
function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb)
}
let isRefreshing=false

/* 刷新请求（refreshSubscribers数组中的请求得到新的token之后会自执行，用新的token去请求数据） */
function onRrefreshed(access) {
  refreshSubscribers.map(cb => cb(access))
}

//请求拦截
http.interceptors.request.use(async config=>{
    // console.log(config,'----------发起');
    let retry = new Promise((resolve, reject) => {
        /* (token) => {...}这个函数就是回调函数 */
        subscribeTokenRefresh((access) => {
          config.headers.Authorization = 'Bearer '+ access
          /* 将请求挂起 */
          resolve(config)
        })
    })
    let resetTime=sessionStorage.getItem("resetTime")
    let currentTime=Date.now()
    if((currentTime>Number(resetTime)) && resetTime!=null){//token超期
        if(!isRefreshing){
            isRefreshing = true;
            onRrefreshed(await refreshToken());
            isRefreshing = false;
        }
      }else{//token未超期，直接返回token不改变
        onRrefreshed(getToken());
      }

      return retry
})
//响应拦截
http.interceptors.response.use(response=>{
    // console.log(response,'----------返回');
    return response
},error=>{
  console.log(error.response,'==============返回error');
  let response = error.response;
  const status = response.status;
    if (status === 401) {
        // 判断状态码是401 跳转到登录
        DelToken()
        DelUserInfo()
        alert(error.message)
        location.reload(); 
    }
    return Promise.reject(error)
    
})
//抛出模块
export default http


// WEBPACK FOOTER //
// ./src/common/axiosConfig.js